"use client";
const n = `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: var(--ikp-color-gray-200); /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: var(--ikp-font-family-mono); /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: var(--ikp-color-gray-400); /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: var(--ikp-color-gray-400); /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-\\[unset\\] {
  inset: unset;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-\\[unset\\] {
  left: unset;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-6 {
  right: 1.5rem;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-\\[5\\%\\] {
  top: 5%;
}
.z-base {
  z-index: var(--ikp-z-index-base);
}
.z-dropdown {
  z-index: var(--ikp-z-index-dropdown);
}
.z-modal {
  z-index: var(--ikp-z-index-modal);
}
.z-overlay {
  z-index: var(--ikp-z-index-overlay);
}
.z-popover {
  z-index: var(--ikp-z-index-popover);
}
.z-start {
  z-index: var(--ikp-z-index-start);
}
.m-\\[0px_0px_0\\.5em\\] {
  margin: 0px 0px 0.5em;
}
.m-auto {
  margin: auto;
}
.-my-\\[1px\\] {
  margin-top: -1px;
  margin-bottom: -1px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-\\[5px\\] {
  margin-left: 5px;
  margin-right: 5px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-\\[\\.1rem\\] {
  margin-top: .1rem;
  margin-bottom: .1rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[3px\\] {
  margin-left: 3px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-\\[0\\.5em\\] {
  margin-right: 0.5em;
}
.mr-\\[var\\(--removed-body-scroll-bar-size\\)\\] {
  margin-right: var(--removed-body-scroll-bar-size);
}
.mr-auto {
  margin-right: auto;
}
.ms-\\[1em\\] {
  margin-inline-start: 1em;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-8 {
  margin-top: 2rem;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\!line-clamp-none {
  overflow: visible !important;
  display: block !important;
  -webkit-box-orient: horizontal !important;
  -webkit-line-clamp: none !important;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.size-10 {
  width: 2.5rem;
  height: 2.5rem;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[27\\.88px\\] {
  height: 27.88px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[calc\\(100\\%-24px\\)\\] {
  height: calc(100% - 24px);
}
.h-\\[var\\(--ask-ai-trigger-height\\)\\] {
  height: var(--ask-ai-trigger-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[100vw\\] {
  max-height: 100vw;
}
.max-h-\\[10vh\\] {
  max-height: 10vh;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[min\\(85vh\\2c 850px\\)\\] {
  max-height: min(85vh,850px);
}
.max-h-full {
  max-height: 100%;
}
.max-h-screen {
  max-height: 100vh;
}
.\\!min-h-0 {
  min-height: 0px !important;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-20 {
  min-height: 5rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-9 {
  min-height: 2.25rem;
}
.min-h-\\[38px\\] {
  min-height: 38px;
}
.min-h-\\[unset\\] {
  min-height: unset;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[254px\\] {
  width: 254px;
}
.w-\\[calc\\(100\\%_-_theme\\(spacing\\.5\\)\\)\\] {
  width: calc(100% - 1.25rem);
}
.w-\\[min\\(90vw\\2c 720px\\)\\] {
  width: min(90vw,720px);
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.\\!min-w-0 {
  min-width: 0px !important;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-6 {
  min-width: 1.5rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[unset\\] {
  min-width: unset;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[480px\\] {
  max-width: 480px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-\\[0_0_100\\%\\] {
  flex: 0 0 100%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow-0 {
  flex-grow: 0;
}
.grow-\\[1\\] {
  flex-grow: 1;
}
.grow-\\[2\\] {
  flex-grow: 2;
}
.grow-\\[5\\] {
  flex-grow: 5;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-30deg\\] {
  --tw-rotate: -30deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-none {
  transform: none;
}
@keyframes bounce-dot {

  0%, 100% {
    transform: translateY(0);
    opacity: 0.3;
  }

  50% {
    transform: translateY(-5px);
    opacity: 1;
  }
}
.animate-bounce-dot {
  animation: bounce-dot 1.5s infinite ease-in-out;
}
@keyframes checkbox-check {

  from {
    opacity: 0;
    stroke-dashoffset: 16;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    stroke-dashoffset: 0;
    transform: scale(1);
  }
}
.animate-checkbox-check {
  animation: checkbox-check 200ms linear;
}
@keyframes shimmer {

  0% {
    background-size: 200% 200%;
    background-position: 100% 0;
  }

  100% {
    background-size: 200% 200%;
    background-position: -100% 0;
  }
}
.animate-shimmer {
  animation: shimmer 3.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes skeleton-bg-fade {

  from {
    border-color: var(--start-color);
    background: var(--start-color);
  }

  to {
    border-color: var(--end-color);
    background: var(--end-color);
  }
}
.animate-skeleton-bg-fade {
  animation: 0.8s linear infinite alternate skeleton-bg-fade;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.list-\\[initial\\] {
  list-style-type: initial;
}
.list-decimal {
  list-style-type: decimal;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}
.place-items-center {
  place-items: center;
}
.content-center {
  align-content: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[1rem_0\\.5rem\\] {
  gap: 1rem 0.5rem;
}
.gap-x-3 {
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.justify-self-end {
  justify-self: end;
}
.justify-self-center {
  justify-self: center;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[0_0_6px_6px\\] {
  border-radius: 0 0 6px 6px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[6px_6px_0_0\\] {
  border-radius: 6px 6px 0 0;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-none {
  border-style: none;
}
.border-\\[--end-color\\] {
  border-color: var(--end-color);
}
.border-gray-100 {
  border-color: var(--ikp-color-gray-100);
}
.border-gray-200 {
  border-color: var(--ikp-color-gray-200);
}
.border-gray-300 {
  border-color: var(--ikp-color-gray-300);
}
.border-inherit {
  border-color: inherit;
}
.border-inkeep-expanded-primary-200 {
  border-color: var(--ikp-color-inkeep-expanded-primary-200);
}
.border-transparent {
  border-color: transparent;
}
.border-white-alpha-200 {
  border-color: var(--ikp-color-white-alpha-200);
}
.border-l-transparent {
  border-left-color: transparent;
}
.bg-\\[--start-color\\] {
  background-color: var(--start-color);
}
.bg-gray-100 {
  background-color: var(--ikp-color-gray-100);
}
.bg-gray-1000 {
  background-color: var(--ikp-color-gray-1000);
}
.bg-gray-300 {
  background-color: var(--ikp-color-gray-300);
}
.bg-gray-50 {
  background-color: var(--ikp-color-gray-50);
}
.bg-inherit {
  background-color: inherit;
}
.bg-inkeep-primary-lighter {
  background-color: var(--ikp-color-inkeep-primary-lighter);
}
.bg-inkeep-primary-medium {
  background-color: var(--ikp-color-inkeep-primary-medium);
}
.bg-inkeep-primary-text-bold {
  background-color: var(--ikp-color-inkeep-primary-text-bold);
}
.bg-overlay-light {
  background-color: var(--ikp-color-overlay-light);
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-gray-100 {
  --tw-gradient-from: var(--ikp-color-gray-100) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-700 {
  --tw-gradient-from: var(--ikp-color-gray-700) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-gray-400 {
  --tw-gradient-to: var(--ikp-color-gray-400) var(--tw-gradient-to-position);
}
.bg-clip-padding {
  background-clip: padding-box;
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.fill-white {
  fill: #fff;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[1em\\] {
  padding: 1em;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[\\.4rem\\] {
  padding-left: .4rem;
  padding-right: .4rem;
}
.px-\\[18px\\] {
  padding-left: 18px;
  padding-right: 18px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[\\.2rem\\] {
  padding-top: .2rem;
  padding-bottom: .2rem;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.font-body {
  font-family: var(--ikp-font-family-body);
}
.font-heading {
  font-family: var(--ikp-font-family-heading);
}
.font-mono {
  font-family: var(--ikp-font-family-mono);
}
.text-1sm {
  font-size: var(--ikp-font-size-1sm);
}
.text-2sm {
  font-size: var(--ikp-font-size-2sm);
}
.text-2xs {
  font-size: var(--ikp-font-size-2xs);
}
.text-3xl {
  font-size: var(--ikp-font-size-3xl);
}
.text-3xs {
  font-size: var(--ikp-font-size-3xs);
}
.text-lg {
  font-size: var(--ikp-font-size-lg);
}
.text-md {
  font-size: var(--ikp-font-size-md);
}
.text-sm {
  font-size: var(--ikp-font-size-sm);
}
.text-xl {
  font-size: var(--ikp-font-size-xl);
}
.text-xs {
  font-size: var(--ikp-font-size-xs);
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[1\\.25\\] {
  line-height: 1.25;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1em\\] {
  line-height: 1em;
}
.leading-\\[unset\\] {
  line-height: unset;
}
.leading-snug {
  line-height: 1.375;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-current {
  color: currentColor;
}
.text-gray-400 {
  color: var(--ikp-color-gray-400);
}
.text-gray-500 {
  color: var(--ikp-color-gray-500);
}
.text-gray-600 {
  color: var(--ikp-color-gray-600);
}
.text-gray-700 {
  color: var(--ikp-color-gray-700);
}
.text-gray-800 {
  color: var(--ikp-color-gray-800);
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-inkeep-primary-medium {
  color: var(--ikp-color-inkeep-primary-medium);
}
.text-inkeep-primary-strong {
  color: var(--ikp-color-inkeep-primary-strong);
}
.text-inkeep-primary-stronger {
  color: var(--ikp-color-inkeep-primary-stronger);
}
.text-inkeep-primary-text-bold {
  color: var(--ikp-color-inkeep-primary-text-bold);
}
.text-inkeep-primary-text-color-on-primary {
  color: var(--ikp-color-inkeep-primary-text-color-on-primary);
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-45 {
  opacity: 0.45;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_2px_var\\(--shadow-color\\)\\] {
  --tw-shadow: 0 0 0 2px var(--shadow-color);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_25px_50px_-12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 25px 50px -12px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 8px 30px rgba(0,0,0,0.12);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_0_0_1px_currentColor\\] {
  --tw-shadow: inset 0 0 0 1px currentColor;
  --tw-shadow-colored: inset 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[none\\] {
  --tw-shadow-color: none;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition-\\[common\\] {
  transition-property: common;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-\\[160ms\\] {
  transition-duration: 160ms;
}
.duration-\\[180\\] {
  transition-duration: 180;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[--ask-ai-trigger-height\\:0px\\] {
  --ask-ai-trigger-height: 0px;
}
.\\[--end-color\\:theme\\(colors\\.gray\\.300\\)\\] {
  --end-color: var(--ikp-color-gray-300);
}
.\\[--end-color\\:theme\\(colors\\.inkeep-expanded-primary\\.700\\)\\] {
  --end-color: var(--ikp-color-inkeep-expanded-primary-700);
}
.\\[--end-color\\:theme\\(colors\\.white-alpha\\.100\\)\\] {
  --end-color: var(--ikp-color-white-alpha-100);
}
.\\[--error-border-color\\:theme\\(colors\\.red\\.500\\)\\] {
  --error-border-color: #ef4444;
}
.\\[--focus-border-color\\:theme\\(colors\\.blue\\.500\\)\\] {
  --focus-border-color: #3b82f6;
}
.\\[--footer-height\\:theme\\(spacing\\.9\\)\\] {
  --footer-height: 2.25rem;
}
.\\[--scrollbar-color\\:var\\(--color-gray-300\\)\\] {
  --scrollbar-color: var(--color-gray-300);
}
.\\[--start-color\\:theme\\(colors\\.gray\\.50\\)\\] {
  --start-color: var(--ikp-color-gray-50);
}
.\\[--start-color\\:theme\\(colors\\.inkeep-expanded-primary\\.300\\)\\] {
  --start-color: var(--ikp-color-inkeep-expanded-primary-300);
}
.\\[counter-increment\\:item\\] {
  counter-increment: item;
}
.\\[counter-reset\\:item_calc\\(var\\(--start\\2c 0\\)_-_1\\)\\] {
  counter-reset: item calc(var(--start,0) - 1);
}
.\\[font-size\\:85\\%\\!important\\] {
  font-size: 85% !important;
}
.\\[font-variant-numeric\\:lining-nums_tabular-nums\\] {
  font-variant-numeric: lining-nums tabular-nums;
}
.\\[grid-area\\:breadcrumbs\\] {
  grid-area: breadcrumbs;
}
.\\[grid-area\\:description\\] {
  grid-area: description;
}
.\\[grid-area\\:icon\\] {
  grid-area: icon;
}
.\\[grid-area\\:indicator\\] {
  grid-area: indicator;
}
.\\[grid-area\\:tag\\] {
  grid-area: tag;
}
.\\[grid-area\\:title\\] {
  grid-area: title;
}
.\\[grid-template\\:\\"breadcrumbs_breadcrumbs_breadcrumbs_indicator\\"\\"icon_title_tag_indicator\\"\\"description_description_description_indicator\\"\\/auto_auto_1fr_auto\\] {
  grid-template: "breadcrumbs breadcrumbs breadcrumbs indicator""icon title tag indicator""description description description indicator"/auto auto 1fr auto;
}
.\\[inset-inline-start\\:var\\(--start\\2c 0px\\)\\] {
  inset-inline-start: var(--start,0px);
}
.\\[overflow-wrap\\:anywhere\\] {
  overflow-wrap: anywhere;
}
.\\[scrollbar-color\\:var\\(--scrollbar-color\\)_transparent\\] {
  scrollbar-color: var(--scrollbar-color) transparent;
}
.\\[scrollbar-width\\:thin\\] {
  scrollbar-width: thin;
}
.\\[transition-duration\\:0\\.02s\\] {
  transition-duration: 0.02s;
}
.\\[transition-property\\:common\\] {
  transition-property: common;
}

:where(.inkeep-widget-vars) {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: var(--ikp-font-family-body);
  font-size: var(--ikp-font-size-md);
  line-height: 1.5;
  color: var(--ikp-color-gray-800);
}

[data-theme='dark'] :where(.inkeep-widget-vars) {
  color: var(--ikp-color-white-alpha-950);
}

:where(.inkeep-widget-vars) *,
:where(.inkeep-widget-vars) *::before,
:where(.inkeep-widget-vars) *::after {
  border-color: var(--ikp-color-gray-200);
}

[data-theme='dark'] :where(.inkeep-widget-vars) *,
[data-theme='dark'] :where(.inkeep-widget-vars) *::before,
[data-theme='dark'] :where(.inkeep-widget-vars) *::after {
  border-color: var(--ikp-color-white-alpha-200);
}

:where(.inkeep-widget-vars) input::-moz-placeholder, :where(.inkeep-widget-vars) textarea::-moz-placeholder {
  color: var(--ikp-color-gray-500);
}

:where(.inkeep-widget-vars) input::placeholder,
:where(.inkeep-widget-vars) textarea::placeholder {
  color: var(--ikp-color-gray-500);
}

[data-theme='dark'] :where(.inkeep-widget-vars) input::-moz-placeholder, [data-theme='dark'] :where(.inkeep-widget-vars) textarea::-moz-placeholder {
  color: var(--ikp-color-white-alpha-500);
}

[data-theme='dark'] :where(.inkeep-widget-vars) input::placeholder,
[data-theme='dark'] :where(.inkeep-widget-vars) textarea::placeholder {
  color: var(--ikp-color-white-alpha-500);
}

:where(.inkeep-widget-vars) [data-part='icon'][data-type='built-in'] {
  display: inline-block;
  min-height: 1em;
  min-width: 1em;
  flex-shrink: 0;
  vertical-align: middle;
  line-height: 1em;
}

svg[data-part='icon'][data-type='custom'] {
  /* we don't want the wrapper divs to affect layout / positioning of icon */
  display: contents;
}

svg[data-part='icon'][data-type='custom'] div {
  display: contents;
}

img[data-part='icon'][data-type='custom'] {
  display: inline-block;
  min-height: 1em;
  min-width: 1em;
}

.\\*\\:invisible > * {
  visibility: hidden;
}

.\\*\\:m-0 > * {
  margin: 0px;
}

.file\\:h-full::file-selector-button {
  height: 100%;
}

.file\\:cursor-pointer::file-selector-button {
  cursor: pointer;
}

.file\\:border-none::file-selector-button {
  border-style: none;
}

.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}

.file\\:text-sm::file-selector-button {
  font-size: var(--ikp-font-size-sm);
}

.file\\:font-medium::file-selector-button {
  font-weight: 500;
}

.file\\:text-gray-700::file-selector-button {
  color: var(--ikp-color-gray-700);
}

.placeholder\\:text-gray-500::-moz-placeholder {
  color: var(--ikp-color-gray-500);
}

.placeholder\\:text-gray-500::placeholder {
  color: var(--ikp-color-gray-500);
}

.before\\:pointer-events-none::before {
  content: var(--tw-content);
  pointer-events: none;
}

.before\\:invisible::before {
  content: var(--tw-content);
  visibility: hidden;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.before\\:z-hide::before {
  content: var(--tw-content);
  z-index: var(--ikp-z-index-hide);
}

.before\\:m-auto::before {
  content: var(--tw-content);
  margin: auto;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:h-3::before {
  content: var(--tw-content);
  height: 0.75rem;
}

.before\\:h-\\[--before-size\\]::before {
  content: var(--tw-content);
  height: var(--before-size);
}

.before\\:w-\\[--before-size\\]::before {
  content: var(--tw-content);
  width: var(--before-size);
}

.before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}

.before\\:-translate-y-full::before {
  content: var(--tw-content);
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:bg-gray-300::before {
  content: var(--tw-content);
  background-color: var(--ikp-color-gray-300);
}

.before\\:bg-gradient-to-b::before {
  content: var(--tw-content);
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.before\\:from-transparent::before {
  content: var(--tw-content);
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.before\\:to-white::before {
  content: var(--tw-content);
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}

.before\\:bg-no-repeat::before {
  content: var(--tw-content);
  background-repeat: no-repeat;
}

.before\\:\\[background-position\\:0_0\\]::before {
  content: var(--tw-content);
  background-position: 0 0;
}

.before\\:\\[background-size\\:cover\\]::before {
  content: var(--tw-content);
  background-size: cover;
}

.after\\:invisible::after {
  content: var(--tw-content);
  visibility: hidden;
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}

.after\\:left-\\[1px\\]::after {
  content: var(--tw-content);
  left: 1px;
}

.after\\:top-\\[1px\\]::after {
  content: var(--tw-content);
  top: 1px;
}

.after\\:z-base::after {
  content: var(--tw-content);
  z-index: var(--ikp-z-index-base);
}

.after\\:h-\\[calc\\(100\\%-2px\\)\\]::after {
  content: var(--tw-content);
  height: calc(100% - 2px);
}

.after\\:w-\\[calc\\(100\\%-2px\\)\\]::after {
  content: var(--tw-content);
  width: calc(100% - 2px);
}

.after\\:rounded-\\[5px\\]::after {
  content: var(--tw-content);
  border-radius: 5px;
}

.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.after\\:bg-gradient-to-t::after {
  content: var(--tw-content);
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}

.last-of-type\\:hidden:last-of-type {
  display: none;
}

.focus\\:z-base:focus {
  z-index: var(--ikp-z-index-base);
}

.focus\\:z-start:focus {
  z-index: var(--ikp-z-index-start);
}

.focus\\:bg-gray-100:focus {
  background-color: var(--ikp-color-gray-100);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-inkeep-expanded-primary-700:focus {
  outline-color: var(--ikp-color-inkeep-expanded-primary-700);
}

.focus\\:\\[--shadow-color\\:theme\\(colors\\.blue\\.500\\)\\]:focus {
  --shadow-color: #3b82f6;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-transparent:focus-visible {
  --tw-ring-color: transparent;
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-transparent:focus-visible {
  --tw-ring-offset-color: transparent;
}

.active\\:bg-gray-200:active {
  background-color: var(--ikp-color-gray-200);
}

.active\\:bg-gray-300:active {
  background-color: var(--ikp-color-gray-300);
}

.active\\:bg-gray-50:active {
  background-color: var(--ikp-color-gray-50);
}

.active\\:bg-gray-900:active {
  background-color: var(--ikp-color-gray-900);
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:text-gray-500:disabled {
  color: var(--ikp-color-gray-500);
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.active\\:disabled\\:\\[background\\:none\\]:disabled:active {
  background: none;
}

.group:hover .group-hover\\:text-gray-600 {
  color: var(--ikp-color-gray-600);
}

.has-\\[\\[data-dual-pane-search-expanded\\]\\]\\:w-\\[min\\(90vw\\2c 1000px\\)\\]:has([data-dual-pane-search-expanded]) {
  width: min(90vw,1000px);
}

.has-\\[\\[data-scroll-top\\]\\]\\:before\\:opacity-0:has([data-scroll-top])::before {
  content: var(--tw-content);
  opacity: 0;
}

.has-\\[\\[data-scroll-bottom\\]\\]\\:after\\:opacity-0:has([data-scroll-bottom])::after {
  content: var(--tw-content);
  opacity: 0;
}

.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}

.data-\\[mobile\\]\\:inset-0[data-mobile] {
  inset: 0px;
}

.data-\\[even\\]\\:ml-0[data-even] {
  margin-left: 0px;
}

.data-\\[even\\]\\:mr-4[data-even] {
  margin-right: 1rem;
}

.data-\\[role\\=user\\]\\:ml-0[data-role="user"] {
  margin-left: 0px;
}

.data-\\[role\\=user\\]\\:block[data-role="user"] {
  display: block;
}

.data-\\[has-results\\]\\:flex[data-has-results] {
  display: flex;
}

.data-\\[escalated\\]\\:hidden[data-escalated] {
  display: none;
}

.data-\\[hidden\\]\\:hidden[data-hidden] {
  display: none;
}

.data-\\[role\\=user\\]\\:hidden[data-role="user"] {
  display: none;
}

.data-\\[state\\=closed\\]\\:hidden[data-state="closed"] {
  display: none;
}

.data-\\[submitted\\]\\:hidden[data-submitted] {
  display: none;
}

.data-\\[has-content\\]\\:h-\\[min\\(calc\\(85vh_-_72px\\)\\2c calc\\(850px_-_72px_-_275px\\)\\)\\][data-has-content] {
  height: min(calc(85vh - 72px),calc(850px - 72px - 275px));
}

.data-\\[mobile\\]\\:h-\\[unset\\][data-mobile] {
  height: unset;
}

.data-\\[composite\\]\\:w-full[data-composite] {
  width: 100%;
}

.data-\\[mobile\\]\\:w-\\[unset\\][data-mobile] {
  width: unset;
}

.data-\\[role\\=user\\]\\:grow-0[data-role="user"] {
  flex-grow: 0;
}

.data-\\[side\\=bottom\\]\\:translate-y-1\\.5[data-side="bottom"] {
  --tw-translate-y: 0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=left\\]\\:-translate-x-1\\.5[data-side="left"] {
  --tw-translate-x: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=right\\]\\:translate-x-1\\.5[data-side="right"] {
  --tw-translate-x: 0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[side\\=top\\]\\:-translate-y-1\\.5[data-side="top"] {
  --tw-translate-y: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.data-\\[mobile\\]\\:transform-none[data-mobile] {
  transform: none;
}

@keyframes fade-out {

  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.data-\\[state\\=closed\\]\\:animate-fade-out[data-state="closed"] {
  animation: fade-out 0.2s ease-out;
}

@keyframes fade-in {

  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.data-\\[state\\=open\\]\\:animate-fade-in[data-state="open"] {
  animation: fade-in 0.25s ease-out;
}

.data-\\[loading\\]\\:cursor-wait[data-loading] {
  cursor: wait;
}

.data-\\[even\\]\\:flex-row[data-even] {
  flex-direction: row;
}

.data-\\[input-type\\=checkbox\\]\\:flex-row[data-input-type="checkbox"] {
  flex-direction: row;
}

.data-\\[even\\]\\:items-start[data-even] {
  align-items: flex-start;
}

.data-\\[input-type\\=checkbox\\]\\:items-center[data-input-type="checkbox"] {
  align-items: center;
}

.data-\\[role\\=user\\]\\:justify-end[data-role="user"] {
  justify-content: flex-end;
}

.data-\\[role\\=user\\]\\:whitespace-pre-wrap[data-role="user"] {
  white-space: pre-wrap;
}

.data-\\[mobile\\]\\:rounded-none[data-mobile] {
  border-radius: 0px;
}

.data-\\[invalid\\]\\:border-\\[--error-border-color\\][data-invalid] {
  border-color: var(--error-border-color);
}

.data-\\[state\\=active\\]\\:border-inkeep-primary-medium-subtle[data-state="active"] {
  border-color: var(--ikp-color-inkeep-primary-medium-subtle);
}

.data-\\[state\\=checked\\]\\:border-gray-1000[data-state="checked"] {
  border-color: var(--ikp-color-gray-1000);
}

.data-\\[active\\]\\:bg-white[data-active] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.data-\\[role\\=user\\]\\:bg-gray-50[data-role="user"] {
  background-color: var(--ikp-color-gray-50);
}

.data-\\[state\\=active\\]\\:bg-inkeep-primary-light-subtle[data-state="active"] {
  background-color: var(--ikp-color-inkeep-primary-light-subtle);
}

.data-\\[state\\=checked\\]\\:bg-gray-1000[data-state="checked"] {
  background-color: var(--ikp-color-gray-1000);
}

.data-\\[username\\]\\:bg-inkeep-primary-lighter[data-username] {
  background-color: var(--ikp-color-inkeep-primary-lighter);
}

.data-\\[has-content\\]\\:pb-2[data-has-content] {
  padding-bottom: 0.5rem;
}

.data-\\[is-numeric\\=true\\]\\:text-end[data-is-numeric="true"] {
  text-align: end;
}

.data-\\[highlighted\\]\\:font-semibold[data-highlighted] {
  font-weight: 600;
}

.data-\\[active\\]\\:text-gray-600[data-active] {
  color: var(--ikp-color-gray-600);
}

.data-\\[active\\]\\:text-gray-800[data-active] {
  color: var(--ikp-color-gray-800);
}

.data-\\[copied\\]\\:text-inkeep-primary-medium[data-copied] {
  color: var(--ikp-color-inkeep-primary-medium);
}

.data-\\[downvoted\\]\\:text-inkeep-primary-medium[data-downvoted] {
  color: var(--ikp-color-inkeep-primary-medium);
}

.data-\\[highlighted\\]\\:text-inkeep-primary-text-subtle[data-highlighted] {
  color: var(--ikp-color-inkeep-primary-text-subtle);
}

.data-\\[is-match\\]\\:text-inkeep-expanded-primary-700[data-is-match] {
  color: var(--ikp-color-inkeep-expanded-primary-700);
}

.data-\\[role\\=user\\]\\:text-gray-700[data-role="user"] {
  color: var(--ikp-color-gray-700);
}

.data-\\[state\\=active\\]\\:text-inkeep-expanded-primary-900[data-state="active"] {
  color: var(--ikp-color-inkeep-expanded-primary-900);
}

.data-\\[state\\=checked\\]\\:text-white[data-state="checked"] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.data-\\[type\\=\\"stackoverflow\\"\\]\\:text-green-500[data-type="stackoverflow"] {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}

.data-\\[type\\=icon\\]\\:data-\\[role\\=user\\]\\:text-inkeep-primary-medium[data-role="user"][data-type="icon"] {
  color: var(--ikp-color-inkeep-primary-medium);
}

.data-\\[type\\^\\=\\"github\\"\\]\\:text-purple-500[data-type^="github"] {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}

.data-\\[upvoted\\]\\:text-inkeep-primary-medium[data-upvoted] {
  color: var(--ikp-color-inkeep-primary-medium);
}

.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}

.data-\\[active\\]\\:shadow[data-active] {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[invalid\\]\\:shadow-\\[0_0_0_1px_var\\(--error-border-color\\)\\][data-invalid] {
  --tw-shadow: 0 0 0 1px var(--error-border-color);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.data-\\[disable-transitions\\]\\:transition-none[data-disable-transitions] {
  transition-property: none;
}

.data-\\[type\\=icon\\]\\:\\[--end-color\\:theme\\(colors\\.inkeep-expanded-primary\\.300\\)\\][data-type="icon"] {
  --end-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.data-\\[type\\=icon\\]\\:data-\\[role\\=assistant\\]\\:\\[--end-color\\:theme\\(colors\\.inkeep-expanded-primary\\.700\\)\\][data-role="assistant"][data-type="icon"] {
  --end-color: var(--ikp-color-inkeep-expanded-primary-700);
}

.data-\\[mobile\\]\\:\\[--input-height\\:theme\\(spacing\\.16\\)\\][data-mobile] {
  --input-height: 4rem;
}

.data-\\[invalid\\]\\:\\[--shadow-color\\:theme\\(colors\\.red\\.500\\)\\][data-invalid] {
  --shadow-color: #ef4444;
}

.data-\\[type\\=icon\\]\\:data-\\[role\\=assistant\\]\\:\\[--start-color\\:theme\\(colors\\.inkeep-expanded-primary\\.300\\)\\][data-role="assistant"][data-type="icon"] {
  --start-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.data-\\[type\\=icon\\]\\:\\[--start-color\\:theme\\(colors\\.inkeep-expanded-primary\\.50\\)\\][data-type="icon"] {
  --start-color: var(--ikp-color-inkeep-expanded-primary-50);
}

.data-\\[required\\]\\:after\\:absolute[data-required]::after {
  content: var(--tw-content);
  position: absolute;
}

.data-\\[show-toolbar\\]\\:after\\:absolute[data-show-toolbar]::after {
  content: var(--tw-content);
  position: absolute;
}

.data-\\[show-toolbar\\]\\:after\\:left-0[data-show-toolbar]::after {
  content: var(--tw-content);
  left: 0px;
}

.data-\\[show-toolbar\\]\\:after\\:top-full[data-show-toolbar]::after {
  content: var(--tw-content);
  top: 100%;
}

.data-\\[show-toolbar\\]\\:after\\:z-start[data-show-toolbar]::after {
  content: var(--tw-content);
  z-index: var(--ikp-z-index-start);
}

.data-\\[required\\]\\:after\\:ml-1[data-required]::after {
  content: var(--tw-content);
  margin-left: 0.25rem;
}

.data-\\[required\\]\\:after\\:mt-0[data-required]::after {
  content: var(--tw-content);
  margin-top: 0px;
}

.data-\\[show-toolbar\\]\\:after\\:h-\\[1rem\\][data-show-toolbar]::after {
  content: var(--tw-content);
  height: 1rem;
}

.data-\\[show-toolbar\\]\\:after\\:w-full[data-show-toolbar]::after {
  content: var(--tw-content);
  width: 100%;
}

.data-\\[show-toolbar\\]\\:after\\:bg-\\[linear-gradient\\(currentColor\\2c _transparent\\)\\][data-show-toolbar]::after {
  content: var(--tw-content);
  background-image: linear-gradient(currentColor, transparent);
}

.data-\\[required\\]\\:after\\:text-red-500[data-required]::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.data-\\[show-toolbar\\]\\:after\\:text-white[data-show-toolbar]::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.data-\\[required\\]\\:after\\:\\[content\\:\\"\\*\\"\\][data-required]::after {
  content: "*";
}

@keyframes spin {

  to {
    content: var(--tw-content);
    transform: rotate(360deg);
  }
}

.data-\\[highlight\\]\\:first\\:before\\:animate-\\[spin_4s_linear_infinite\\]:first-child[data-highlight]::before {
  content: var(--tw-content);
  animation: spin 4s linear infinite;
}

.data-\\[highlight\\]\\:first\\:before\\:\\[background-image\\:conic-gradient\\(transparent\\2c theme\\(colors\\.inkeep-expanded-primary\\.600\\)\\2c transparent_30\\%\\)\\]:first-child[data-highlight]::before {
  content: var(--tw-content);
  background-image: conic-gradient(transparent,var(--ikp-color-inkeep-expanded-primary-600),transparent 30%);
}

:not(.dark) .light\\:text-gray-700 {
  color: var(--ikp-color-gray-700);
}

[data-widget-md] .ikp-md\\:mb-0 {
  margin-bottom: 0px;
}

[data-widget-md] .ikp-md\\:flex {
  display: flex;
}

[data-widget-md] .ikp-md\\:hidden {
  display: none;
}

[data-widget-md] .ikp-md\\:h-12 {
  height: 3rem;
}

[data-widget-md] .ikp-md\\:flex-row {
  flex-direction: row;
}

[data-widget-md] .ikp-md\\:flex-col {
  flex-direction: column;
}

[data-widget-md] .ikp-md\\:items-start {
  align-items: flex-start;
}

[data-widget-md] .ikp-md\\:px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}

[data-widget-md] .ikp-md\\:px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

[data-widget-md] .ikp-md\\:px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

[data-widget-md] .ikp-md\\:py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}

[data-widget-md] .ikp-md\\:pb-14 {
  padding-bottom: 3.5rem;
}

[data-widget-md] .ikp-md\\:pl-3 {
  padding-left: 0.75rem;
}

[data-widget-md] .ikp-md\\:pr-3 {
  padding-right: 0.75rem;
}

[data-widget-md] .ikp-md\\:pr-6 {
  padding-right: 1.5rem;
}

.hover\\:scale-110:hover:not(:disabled) {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-gray-300:hover:not(:disabled) {
  border-color: var(--ikp-color-gray-300);
}

.hover\\:bg-gray-100:hover:not(:disabled) {
  background-color: var(--ikp-color-gray-100);
}

.hover\\:bg-gray-200:hover:not(:disabled) {
  background-color: var(--ikp-color-gray-200);
}

.hover\\:bg-gray-50:hover:not(:disabled) {
  background-color: var(--ikp-color-gray-50);
}

.hover\\:bg-gray-900:hover:not(:disabled) {
  background-color: var(--ikp-color-gray-900);
}

.hover\\:bg-inkeep-primary-light-subtle:hover:not(:disabled) {
  background-color: var(--ikp-color-inkeep-primary-light-subtle);
}

.hover\\:bg-transparent:hover:not(:disabled) {
  background-color: transparent;
}

.hover\\:text-gray-700:hover:not(:disabled) {
  color: var(--ikp-color-gray-700);
}

.hover\\:text-gray-800:hover:not(:disabled) {
  color: var(--ikp-color-gray-800);
}

.hover\\:text-inkeep-primary-strong:hover:not(:disabled) {
  color: var(--ikp-color-inkeep-primary-strong);
}

.hover\\:text-inkeep-primary-stronger:hover:not(:disabled) {
  color: var(--ikp-color-inkeep-primary-stronger);
}

.hover\\:underline:hover:not(:disabled) {
  text-decoration-line: underline;
}

.hover\\:disabled\\:bg-gray-100:disabled:hover:not(:disabled) {
  background-color: var(--ikp-color-gray-100);
}

.hover\\:disabled\\:\\[background\\:none\\]:disabled:hover:not(:disabled) {
  background: none;
}

.hover\\:data-\\[state\\=active\\]\\:bg-inkeep-primary-light-subtle[data-state="active"]:hover:not(:disabled) {
  background-color: var(--ikp-color-inkeep-primary-light-subtle);
}

.data-\\[is-match\\]\\:hover\\:text-inkeep-expanded-primary-800:hover:not(:disabled)[data-is-match] {
  color: var(--ikp-color-inkeep-expanded-primary-800);
}

.befter\\:pointer-events-none::before {
  pointer-events: none;
}

.befter\\:absolute::before {
  position: absolute;
}

.befter\\:inset-x-0::before {
  left: 0px;
  right: 0px;
}

.befter\\:h-10::before {
  height: 2.5rem;
}

.befter\\:from-white::before {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.befter\\:to-transparent::before {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

.befter\\:transition-opacity::before {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.befter\\:duration-300::before {
  transition-duration: 300ms;
}

.befter\\:ease-in-out::before {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.befter\\:content-\\[\\"\\"\\]::before {
  --tw-content: "";
  content: var(--tw-content);
}

.befter\\:pointer-events-none::after {
  pointer-events: none;
}

.befter\\:absolute::after {
  position: absolute;
}

.befter\\:inset-x-0::after {
  left: 0px;
  right: 0px;
}

.befter\\:h-10::after {
  height: 2.5rem;
}

.befter\\:from-white::after {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.befter\\:to-transparent::after {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}

.befter\\:transition-opacity::after {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.befter\\:duration-300::after {
  transition-duration: 300ms;
}

.befter\\:ease-in-out::after {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.befter\\:content-\\[\\"\\"\\]::after {
  --tw-content: "";
  content: var(--tw-content);
}

.selected\\:border-inkeep-primary-medium-subtle[data-selected="true"] {
  border-color: var(--ikp-color-inkeep-primary-medium-subtle);
}

.selected\\:bg-inkeep-primary-light-subtle[data-selected="true"] {
  background-color: var(--ikp-color-inkeep-primary-light-subtle);
}

.selected\\:text-inkeep-primary-strong[data-selected="true"] {
  color: var(--ikp-color-inkeep-primary-strong);
}

.selected\\:border-inkeep-primary-medium-subtle:hover {
  border-color: var(--ikp-color-inkeep-primary-medium-subtle);
}

.selected\\:bg-inkeep-primary-light-subtle:hover {
  background-color: var(--ikp-color-inkeep-primary-light-subtle);
}

.selected\\:text-inkeep-primary-strong:hover {
  color: var(--ikp-color-inkeep-primary-strong);
}

.group[data-selected="true"] .group-selected\\:text-inkeep-primary-text-bold {
  color: var(--ikp-color-inkeep-primary-text-bold);
}

.group[data-selected="true"] .group-selected\\:text-inkeep-primary-text-subtle {
  color: var(--ikp-color-inkeep-primary-text-subtle);
}

.group[data-selected="true"] .group-selected\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-selected\\:text-inkeep-primary-text-bold {
  color: var(--ikp-color-inkeep-primary-text-bold);
}

.group:hover .group-selected\\:text-inkeep-primary-text-subtle {
  color: var(--ikp-color-inkeep-primary-text-subtle);
}

.group:hover .group-selected\\:opacity-100 {
  opacity: 1;
}

.dark\\:border-gray-700:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-gray-700);
}

.dark\\:border-gray-dark-500:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-gray-dark-500);
}

.dark\\:border-gray-dark-700:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-gray-dark-700);
}

.dark\\:border-inkeep-expanded-primary-200:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-inkeep-expanded-primary-200);
}

.dark\\:border-transparent:is([data-theme="dark"] *) {
  border-color: transparent;
}

.dark\\:border-white-alpha-200:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-white-alpha-200);
}

.dark\\:bg-gray-dark-600:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-600);
}

.dark\\:bg-gray-dark-700:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-700);
}

.dark\\:bg-gray-dark-800:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-800);
}

.dark\\:bg-gray-dark-900:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-900);
}

.dark\\:bg-gray-dark-950:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-950);
}

.dark\\:bg-inkeep-expanded-primary-300:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:bg-overlay-dark:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-overlay-dark);
}

.dark\\:bg-transparent:is([data-theme="dark"] *) {
  background-color: transparent;
}

.dark\\:bg-white-alpha-100:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-100);
}

.dark\\:bg-white-alpha-200:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-200);
}

.dark\\:bg-white-alpha-50:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-50);
}

.dark\\:from-gray-dark-300:is([data-theme="dark"] *) {
  --tw-gradient-from: var(--ikp-color-gray-dark-300) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-gray-dark-600:is([data-theme="dark"] *) {
  --tw-gradient-from: var(--ikp-color-gray-dark-600) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:to-gray-dark-100:is([data-theme="dark"] *) {
  --tw-gradient-to: var(--ikp-color-gray-dark-100) var(--tw-gradient-to-position);
}

.dark\\:fill-gray-dark-800:is([data-theme="dark"] *) {
  fill: var(--ikp-color-gray-dark-800);
}

.dark\\:text-gray-200:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-200);
}

.dark\\:text-gray-400:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-400);
}

.dark\\:text-gray-dark-100:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-100);
}

.dark\\:text-gray-dark-200:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-200);
}

.dark\\:text-gray-dark-300:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-300);
}

.dark\\:text-gray-dark-400:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-400);
}

.dark\\:text-gray-dark-950:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-950);
}

.dark\\:text-inkeep-expanded-primary-100:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-100);
}

.dark\\:text-inkeep-expanded-primary-300:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:text-inkeep-expanded-primary-500:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-500);
}

.dark\\:text-red-300:is([data-theme="dark"] *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-white-alpha-500:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-500);
}

.dark\\:text-white-alpha-600:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-600);
}

.dark\\:text-white-alpha-700:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-700);
}

.dark\\:text-white-alpha-900:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-900);
}

.dark\\:text-white-alpha-950:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-950);
}

.dark\\:shadow-none:is([data-theme="dark"] *) {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[none\\]:is([data-theme="dark"] *) {
  --tw-shadow-color: none;
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:\\[--end-color\\:theme\\(colors\\.gray-dark\\.600\\)\\]:is([data-theme="dark"] *) {
  --end-color: var(--ikp-color-gray-dark-600);
}

.dark\\:\\[--end-color\\:theme\\(colors\\.inkeep-expanded-primary\\.300\\)\\]:is([data-theme="dark"] *) {
  --end-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:\\[--end-color\\:theme\\(colors\\.white-alpha\\.300\\)\\]:is([data-theme="dark"] *) {
  --end-color: var(--ikp-color-white-alpha-300);
}

.dark\\:\\[--error-border-color\\:theme\\(colors\\.red\\.300\\)\\]:is([data-theme="dark"] *) {
  --error-border-color: #fca5a5;
}

.dark\\:\\[--focus-border-color\\:theme\\(colors\\.blue\\.300\\)\\]:is([data-theme="dark"] *) {
  --focus-border-color: #93c5fd;
}

.dark\\:\\[--scrollbar-color\\:var\\(--color-gray-dark-600\\)\\]:is([data-theme="dark"] *) {
  --scrollbar-color: var(--color-gray-dark-600);
}

.dark\\:\\[--start-color\\:theme\\(colors\\.gray-dark\\.800\\)\\]:is([data-theme="dark"] *) {
  --start-color: var(--ikp-color-gray-dark-800);
}

.dark\\:\\[--start-color\\:theme\\(colors\\.gray\\.300\\)\\]:is([data-theme="dark"] *) {
  --start-color: var(--ikp-color-gray-300);
}

.dark\\:\\[--start-color\\:theme\\(colors\\.inkeep-expanded-primary\\.50\\)\\]:is([data-theme="dark"] *) {
  --start-color: var(--ikp-color-inkeep-expanded-primary-50);
}

.dark\\:file\\:text-white-alpha-700:is([data-theme="dark"] *)::file-selector-button {
  color: var(--ikp-color-white-alpha-700);
}

.dark\\:placeholder\\:text-gray-dark-200:is([data-theme="dark"] *)::-moz-placeholder {
  color: var(--ikp-color-gray-dark-200);
}

.dark\\:placeholder\\:text-gray-dark-200:is([data-theme="dark"] *)::placeholder {
  color: var(--ikp-color-gray-dark-200);
}

.dark\\:before\\:bg-gray-dark-950:is([data-theme="dark"] *)::before {
  content: var(--tw-content);
  background-color: var(--ikp-color-gray-dark-950);
}

.dark\\:before\\:to-gray-dark-950:is([data-theme="dark"] *)::before {
  content: var(--tw-content);
  --tw-gradient-to: var(--ikp-color-gray-dark-950) var(--tw-gradient-to-position);
}

.dark\\:after\\:bg-gray-dark-950:is([data-theme="dark"] *)::after {
  content: var(--tw-content);
  background-color: var(--ikp-color-gray-dark-950);
}

.dark\\:focus\\:bg-gray-dark-800:focus:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-800);
}

.dark\\:focus\\:outline-inkeep-expanded-primary-300:focus:is([data-theme="dark"] *) {
  outline-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:active\\:bg-inkeep-expanded-primary-200:active:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-inkeep-expanded-primary-200);
}

.dark\\:active\\:bg-white-alpha-100:active:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-100);
}

.dark\\:active\\:bg-white-alpha-200:active:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-200);
}

.dark\\:active\\:bg-white-alpha-400:active:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-400);
}

.dark\\:disabled\\:text-white-alpha-200:disabled:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-200);
}

.group:hover .dark\\:group-hover\\:text-white-alpha-600:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-600);
}

.dark\\:data-\\[state\\=active\\]\\:border-inkeep-expanded-primary-300[data-state="active"]:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:data-\\[state\\=checked\\]\\:border-white-alpha-950[data-state="checked"]:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-white-alpha-950);
}

.dark\\:data-\\[active\\]\\:bg-gray-dark-700[data-active]:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-700);
}

.dark\\:data-\\[state\\=active\\]\\:bg-white-alpha-100[data-state="active"]:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-100);
}

.dark\\:data-\\[state\\=checked\\]\\:bg-white-alpha-950[data-state="checked"]:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-950);
}

.dark\\:data-\\[username\\]\\:bg-inkeep-expanded-primary-300[data-username]:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:data-\\[active\\]\\:text-white-alpha-600[data-active]:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-600);
}

.dark\\:data-\\[active\\]\\:text-white-alpha-950[data-active]:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-950);
}

.dark\\:data-\\[highlighted\\]\\:text-gray-dark-50[data-highlighted]:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-50);
}

.dark\\:data-\\[is-match\\]\\:text-inkeep-expanded-primary-300[data-is-match]:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:data-\\[role\\=user\\]\\:text-white-alpha-700[data-role="user"]:is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-700);
}

.dark\\:data-\\[state\\=active\\]\\:text-inkeep-expanded-primary-300[data-state="active"]:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:data-\\[state\\=checked\\]\\:text-gray-1000[data-state="checked"]:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-1000);
}

.dark\\:data-\\[type\\=icon\\]\\:data-\\[role\\=user\\]\\:text-inkeep-expanded-primary-300[data-role="user"][data-type="icon"]:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.data-\\[downvoted\\]\\:dark\\:text-inkeep-expanded-primary-300:is([data-theme="dark"] *)[data-downvoted] {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.data-\\[upvoted\\]\\:dark\\:text-inkeep-expanded-primary-300:is([data-theme="dark"] *)[data-upvoted] {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:data-\\[type\\=icon\\]\\:data-\\[role\\=assistant\\]\\:\\[--end-color\\:theme\\(colors\\.inkeep-expanded-primary\\.300\\)\\][data-role="assistant"][data-type="icon"]:is([data-theme="dark"] *) {
  --end-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:data-\\[type\\=icon\\]\\:data-\\[role\\=assistant\\]\\:\\[--start-color\\:theme\\(colors\\.inkeep-expanded-primary\\.50\\)\\][data-role="assistant"][data-type="icon"]:is([data-theme="dark"] *) {
  --start-color: var(--ikp-color-inkeep-expanded-primary-50);
}

.dark\\:data-\\[required\\]\\:after\\:text-red-300[data-required]:is([data-theme="dark"] *)::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.data-\\[show-toolbar\\]\\:after\\:dark\\:text-gray-dark-950:is([data-theme="dark"] *)[data-show-toolbar]::after {
  content: var(--tw-content);
  color: var(--ikp-color-gray-dark-950);
}

.dark\\:data-\\[highlight\\]\\:first\\:before\\:\\[background-image\\:conic-gradient\\(transparent\\2c theme\\(colors\\.inkeep-expanded-primary\\.300\\)\\2c transparent_30\\%\\)\\]:first-child[data-highlight]:is([data-theme="dark"] *)::before {
  content: var(--tw-content);
  background-image: conic-gradient(transparent,var(--ikp-color-inkeep-expanded-primary-300),transparent 30%);
}

.dark\\:hover\\:border-white-alpha-300:hover:not(:disabled):is([data-theme="dark"] *) {
  border-color: var(--ikp-color-white-alpha-300);
}

.dark\\:hover\\:bg-gray-dark-800:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-gray-dark-800);
}

.dark\\:hover\\:bg-inkeep-expanded-primary-200:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-inkeep-expanded-primary-200);
}

.dark\\:hover\\:bg-transparent:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: transparent;
}

.dark\\:hover\\:bg-white-alpha-100:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-100);
}

.dark\\:hover\\:bg-white-alpha-200:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-200);
}

.dark\\:hover\\:bg-white-alpha-50:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-50);
}

.dark\\:hover\\:text-inkeep-expanded-primary-100:hover:not(:disabled):is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-100);
}

.dark\\:hover\\:text-inkeep-expanded-primary-300:hover:not(:disabled):is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:hover\\:text-white-alpha-500:hover:not(:disabled):is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-500);
}

.dark\\:hover\\:text-white-alpha-800:hover:not(:disabled):is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-800);
}

.dark\\:hover\\:text-white-alpha-950:hover:not(:disabled):is([data-theme="dark"] *) {
  color: var(--ikp-color-white-alpha-950);
}

.hover\\:dark\\:text-white-alpha-950:is([data-theme="dark"] *):hover:not(:disabled) {
  color: var(--ikp-color-white-alpha-950);
}

.dark\\:hover\\:disabled\\:bg-white-alpha-100:disabled:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-100);
}

.dark\\:hover\\:data-\\[state\\=active\\]\\:bg-white-alpha-100[data-state="active"]:hover:not(:disabled):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-100);
}

.dark\\:data-\\[is-match\\]\\:hover\\:text-inkeep-expanded-primary-200:hover:not(:disabled)[data-is-match]:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-200);
}

.befter\\:dark\\:from-gray-dark-950:is([data-theme="dark"] *)::before {
  --tw-gradient-from: var(--ikp-color-gray-dark-950) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.befter\\:dark\\:from-gray-dark-950:is([data-theme="dark"] *)::after {
  --tw-gradient-from: var(--ikp-color-gray-dark-950) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:selected\\:border-inkeep-expanded-primary-300[data-selected="true"]:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:selected\\:bg-white-alpha-200[data-selected="true"]:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-200);
}

.dark\\:selected\\:text-inkeep-expanded-primary-300[data-selected="true"]:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:selected\\:border-inkeep-expanded-primary-300:hover:is([data-theme="dark"] *) {
  border-color: var(--ikp-color-inkeep-expanded-primary-300);
}

.dark\\:selected\\:bg-white-alpha-200:hover:is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-200);
}

.dark\\:selected\\:text-inkeep-expanded-primary-300:hover:is([data-theme="dark"] *) {
  color: var(--ikp-color-inkeep-expanded-primary-300);
}

.group[data-selected="true"] .dark\\:group-selected\\:text-gray-dark-100:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-100);
}

.group[data-selected="true"] .dark\\:group-selected\\:text-white:is([data-theme="dark"] *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-selected\\:text-gray-dark-100:is([data-theme="dark"] *) {
  color: var(--ikp-color-gray-dark-100);
}

.group:hover .dark\\:group-selected\\:text-white:is([data-theme="dark"] *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px) {

  .sm\\:w-\\[420px\\] {
    width: 420px;
  }
}

@media (min-width: 768px) {

  .md\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[min\\(760px\\2c 100\\%\\)\\] {
    height: min(760px,100%);
  }

  .md\\:w-\\[min\\(600px\\2c 100\\%\\)\\] {
    width: min(600px,100%);
  }

  .md\\:min-w-\\[min\\(320px\\2c 100\\%\\)\\] {
    min-width: min(320px,100%);
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:text-4xl {
    font-size: var(--ikp-font-size-4xl);
  }

  .md\\:text-sm {
    font-size: var(--ikp-font-size-sm);
  }

  .md\\:leading-5 {
    line-height: 1.25rem;
  }

  .md\\:data-\\[view\\=dual-pane\\]\\:hidden[data-view="dual-pane"] {
    display: none;
  }

  .md\\:data-\\[dual-pane-search-expanded\\]\\:h-\\[min\\(calc\\(85vh_-_72px\\)\\2c calc\\(900px_-_72px_-_135px\\)\\)\\][data-dual-pane-search-expanded] {
    height: min(calc(85vh - 72px),calc(900px - 72px - 135px));
  }

  .md\\:data-\\[view\\=dual-pane\\]\\:\\[grid-template\\:\\"breadcrumbs_breadcrumbs_breadcrumbs\\"\\"icon_title_tag\\"\\"description_description_description\\"\\/auto_auto_1fr\\][data-view="dual-pane"] {
    grid-template: "breadcrumbs breadcrumbs breadcrumbs""icon title tag""description description description"/auto auto 1fr;
  }
}

@media (min-width: 1024px) {

  .lg\\:h-\\[min\\(800px\\2c 100\\%\\)\\] {
    height: min(800px,100%);
  }

  .lg\\:w-\\[min\\(640px\\2c 100\\%\\)\\] {
    width: min(640px,100%);
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:h-\\[min\\(900px\\2c 100\\%\\)\\] {
    height: min(900px,100%);
  }

  .\\32xl\\:w-\\[min\\(760px\\2c 100\\%\\)\\] {
    width: min(760px,100%);
  }
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:absolute:not(:last-child)::after {
  content: var(--tw-content);
  position: absolute;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:inset-x-6:not(:last-child)::after {
  content: var(--tw-content);
  left: 1.5rem;
  right: 1.5rem;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:bottom-0:not(:last-child)::after {
  content: var(--tw-content);
  bottom: 0px;
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:border-b:not(:last-child)::after {
  content: var(--tw-content);
  border-bottom-width: 1px;
}

[data-widget-md] .ikp-md\\:\\[\\&\\:not\\(\\:last-child\\)\\]\\:after\\:inset-x-8:not(:last-child)::after {
  content: var(--tw-content);
  left: 2rem;
  right: 2rem;
}

.focus\\:\\[\\&\\:not\\(\\[data-invalid\\]\\)\\]\\:border-\\[--focus-border-color\\]:not([data-invalid]):focus {
  border-color: var(--focus-border-color);
}

.focus\\:\\[\\&\\:not\\(\\[data-invalid\\]\\)\\]\\:shadow-\\[0_0_0_1px_var\\(--focus-border-color\\)\\]:not([data-invalid]):focus {
  --tw-shadow: 0 0 0 1px var(--focus-border-color);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.\\[\\&\\:where\\(\\:hover\\2c \\:focus\\)\\]\\:bg-slate-400\\/5:where(:hover,:focus) {
  background-color: rgb(148 163 184 / 0.05);
}

.dark\\:\\[\\&\\:where\\(\\:hover\\2c \\:focus\\)\\]\\:bg-white-alpha-100:where(:hover,:focus):is([data-theme="dark"] *) {
  background-color: var(--ikp-color-white-alpha-100);
}

.\\[\\&\\>\\:first-child\\]\\:basis-full>:first-child {
  flex-basis: 100%;
}

.\\[\\&\\[data-mobile\\]\\>div\\]\\:h-full[data-mobile]>div {
  height: 100%;
}

.\\[\\&\\[data-mobile\\]\\>div\\]\\:max-h-\\[unset\\][data-mobile]>div {
  max-height: unset;
}

.\\[\\&\\[data-mobile\\]\\>div\\]\\:max-h-dvh[data-mobile]>div {
  max-height: 100dvh;
}

.\\[\\&_\\[data-part\\=grid\\]\\]\\:divide-y [data-part=grid] > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}

.\\[\\&_\\[data-part\\=grid\\]\\]\\:px-1 [data-part=grid] {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.\\[\\&_a\\]\\:inline a {
  display: inline;
}

.\\[\\&_a\\]\\:break-words a {
  overflow-wrap: break-word;
}

.\\[\\&_a\\]\\:rounded-sm a {
  border-radius: 0.125rem;
}

.\\[\\&_a\\]\\:bg-inkeep-primary-light a {
  background-color: var(--ikp-color-inkeep-primary-light);
}

.\\[\\&_a\\]\\:px-1 a {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.\\[\\&_a\\]\\:py-\\[1px\\] a {
  padding-top: 1px;
  padding-bottom: 1px;
}

.\\[\\&_a\\]\\:font-semibold a {
  font-weight: 600;
}

.\\[\\&_a\\]\\:text-inkeep-primary-text-subtle a {
  color: var(--ikp-color-inkeep-primary-text-subtle);
}

.\\[\\&_a\\]\\:no-underline a {
  text-decoration-line: none;
}

.\\[\\&_a\\]\\:hover\\:text-inkeep-primary-text-bold:hover:not(:disabled) a {
  color: var(--ikp-color-inkeep-primary-text-bold);
}

.\\[\\&_a\\]\\:hover\\:no-underline:hover:not(:disabled) a {
  text-decoration-line: none;
}

.\\[\\&_a\\]\\:dark\\:bg-inkeep-primary-text-subtle:is([data-theme="dark"] *) a {
  background-color: var(--ikp-color-inkeep-primary-text-subtle);
}

.\\[\\&_a\\]\\:dark\\:hover\\:text-inkeep-expanded-primary-200:hover:not(:disabled):is([data-theme="dark"] *) a {
  color: var(--ikp-color-inkeep-expanded-primary-200);
}

.\\[\\&_em\\]\\:font-bold em {
  font-weight: 700;
}

.\\[\\&_em\\]\\:not-italic em {
  font-style: normal;
}

.\\[\\&_li\\]\\:mb-1 li {
  margin-bottom: 0.25rem;
}

.\\[\\&_svg\\]\\:h-4 svg {
  height: 1rem;
}

.\\[\\&_svg\\]\\:w-4 svg {
  width: 1rem;
}

[data-mobile] .\\[\\[data-mobile\\]_\\&\\]\\:h-\\[calc\\(100vh-var\\(--input-height\\)-var\\(--footer-height\\)-var\\(--ask-ai-trigger-height\\)\\)\\] {
  height: calc(100vh - var(--input-height) - var(--footer-height) - var(--ask-ai-trigger-height));
}

[data-mobile] .\\[\\[data-mobile\\]_\\&\\]\\:h-\\[var\\(--footer-height\\)\\] {
  height: var(--footer-height);
}

[data-mobile] .\\[\\[data-mobile\\]_\\&\\]\\:max-h-\\[var\\(--input-height\\)\\] {
  max-height: var(--input-height);
}

[data-mobile] .\\[\\[data-mobile\\]_\\&\\]\\:items-center {
  align-items: center;
}

[data-mobile] .\\[\\[data-mobile\\]_\\&\\]\\:py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

[data-show-ask-ai-card] .\\[\\[data-show-ask-ai-card\\]_\\&\\]\\:pb-1 {
  padding-bottom: 0.25rem;
}

[data-show-ask-ai-card] .\\[\\[data-show-ask-ai-card\\]_\\&\\]\\:\\[--ask-ai-trigger-height\\:theme\\(spacing\\.11\\)\\] {
  --ask-ai-trigger-height: 2.75rem;
}

[data-view=dual-pane] .\\[\\[data-view\\=dual-pane\\]_\\&\\]\\:block {
  display: block;
}

[data-view=dual-pane] .\\[\\[data-view\\=dual-pane\\]_\\&\\]\\:flex-\\[0_0_40\\%\\] {
  flex: 0 0 40%;
}

[data-view=dual-pane] .first\\:\\[\\[data-view\\=dual-pane\\]_\\&\\]\\:flex-1:first-child {
  flex: 1 1 0%;
}

@media (min-width: 768px) {

  [data-view=dual-pane] .md\\:first\\:\\[\\[data-view\\=dual-pane\\]_\\&\\]\\:flex-\\[0_0_40\\%\\]:first-child {
    flex: 0 0 40%;
  }
}
`;
export {
  n as default
};
